import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const OMSUserSchema_ = z.object({
  roles: z.array(z.string()).nullish(),
  _id: z.string(),
  email: z.string(),
  createdAt: z.coerce.date(),
  firstName: z.string(),
  lastName: z.string(),
  name: z.string(),
  updatedAt: z.coerce.date(),
  team: zExt.objectId(),
});
export const OMSUserSchema: z.ZodType<OMSUser> = OMSUserSchema_;
export interface OMSUser extends z.infer<typeof OMSUserSchema_> {}
export interface IOMSUser extends z.ZodType<OMSUser> {}

export const unassignedUser: OMSUser = {
  roles: null,
  _id: "unassigned",
  email: "",
  createdAt: new Date(),
  firstName: "Unassigned",
  lastName: "",
  name: "Unassigned",
  updatedAt: new Date(),
  team: "",
};
